import type { ReactNode } from 'react'
import { Navbar } from './Navbar'
import { EmailVerifyBanner } from '@/components/auth/EmailVerifyBanner'
import { TermsAcceptanceModal } from '@/components/auth/TermsAcceptanceModal'

export function AppLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <Navbar />
      <EmailVerifyBanner />
      {children}
      <TermsAcceptanceModal />
    </>
  )
}
